import { useState as o } from "react";
import { useDebounceSearchSetState as e } from "../../web/components/Filter/hooks/useDebounceSearchSet.js";
const r = () => {
  const [r2, t] = o(""), [c, n] = e(t);
  return [r2, c, n];
};
export {
  r as useDebounceTextSearch
};
//# sourceMappingURL=useDebounceTextSearch.js.map
